
  module.exports =
  {

    developmentDetails:
    {

      _init: function ()
      {

        $('#set-pickup').not('.js-ignore').click(function ()
        {

          navigator.geolocation.getCurrentPosition(function (position)
          {

            var latitude = position.coords.latitude

            var longitude = position.coords.longitude

            $('#pickup_latitude').val(latitude)

            $('#pickup_longitude').val(longitude)

            $.ajax(APPLICATION._PATH_PREFIX + 'application/bng/' + latitude + '/' + longitude,
            {

              success: function (response)
              {

                data = JSON.parse(response)

                if ('object' === typeof data && 2 === data.length)
                {

                  $('#pickup_easting').val(data[0])

                  $('#pickup_northing').val(data[1])

                }

              }

            }
            )

          }
          )

        }
        ).addClass('.js-ignore')

      }

    },

    plots:
    {

      _init: function()
      {

        if ($('#reported_resolved').val() > 0)
        {

          var url = APPLICATION._PATH_PREFIX + 'plot-issue/has-reported-resolved/' + $('#development_id').val()

          APPLICATION._APPLICATION.customModal(url, 'PlotIssue', 'hasReportedResolved')

        }

        if (navigator.geolocation)
        {

          navigator.geolocation.getCurrentPosition(function (position)
          {

            var back = window.location.pathname,
                path = $('.btn-checkin').data(APPLICATION._DATA_PREFIX + 'modal-path');

            path += '/' + position.coords.latitude + '/' + position.coords.longitude + '?' + back;

            $('.btn-checkin').data(APPLICATION._DATA_PREFIX + 'modal', path);

          })

         }
      }

    },

    // Multi plot problems
    multiPlotProblems:
    {
      _init: function ()
      {
        APPLICATION.Installation.editPlot._init()
      }
    },

    // site connections
    siteOfficeConnection:
    {
      _init: function ()
      {
        var company_id = $('#modal-company_id').val()
        var development = $('#modal-development_id')
        if ('' !== company_id)
        {
          
          // reload development dropdown on failure to submit form
          APPLICATION._APPLICATION.loadDropdown(development, APPLICATION._PATH_PREFIX + 'development/coins-dropdown/' + company_id + '?development_id=' + development.val(), 'Development', 'coinsDropdown')
        }

        $('#modal-company_id').change(function(){
          
          var company_id = $(this).val()
  
          var development = $('#modal-development_id')
  
          if ('' === company_id)
          {
            development.next('.dropdown-menu').html('')
          } 
  
          else
          {
            APPLICATION._APPLICATION.loadDropdown(development, APPLICATION._PATH_PREFIX + 'development/coins-dropdown/' + company_id + '?development_id=' + development.val(), 'Development', 'coinsDropdown')
          }
        })

        $('#office_plot_type_id-modal').not('.js-ignore').change(function ()
        {
        
          if ($(this).val() === $('#office-type-other').val())
          {
            $('#location-wrapper').show()
          }

          else
          {
            $('#location-wrapper').hide()
          }

        }
        ).addClass('js-ignore').trigger('change')

      }
    },

    map:
    {

      _map: null,

      _info: null,

      _init: function ()
      {

        $.getScript('https://maps.googleapis.com/maps/api/js?key=' + APPLICATION._GOOGLEMAPS_API_KEY, function ()
        {

          var mapOptions =
          {
            zoom: 6,
            center: new google.maps.LatLng(54.56, -2.844),
          }

          APPLICATION.Engineer.map._map = new google.maps.Map(document.getElementById('map'), mapOptions)

          window.initMarkers()

        }
        )

      }

    },

    // report fault
    recordFault:
    {

      _init: function ()
      {
  
        $('#modal-company_id').not('.js-ignore').change(function ()
        {
  
          var company_id = $(this).val()
  
          var development = $('#modal-coins_development_id')
  
          if ('' === company_id)
          {
            development.next('.dropdown-menu').html('')
          }
  
          else
          {
            APPLICATION._APPLICATION.loadDropdown(development, APPLICATION._PATH_PREFIX + 'development/coins-dropdown/' + company_id + '?development_id=' + development.val(), 'Development', 'coinsDropdown')
          }
  
        }
        ).addClass('js-ignore').trigger('change')

      }
    
    }

  }
